import { Modal, Typography } from '@sb/cc-design-system';
import { type ReactNode, useCallback, useMemo, useState } from 'react';
import { lang } from 'src/utils';

import { DesignSystemThemeProvider } from '../designSystem/DesignSystemThemeProvider';
import type { INavigationActionHandler } from './navigateBlocker.interface';
import { NavigateBlockerContext } from './NavigateBlockerProvider';

export const NavigateBlockerProviderV2 = ({
  children,
}: {
  children: ReactNode;
}) => {
  const defaultModalState = useMemo(
    () => ({
      isOpen: false,
      proceedNavigation: () => {},
      resetNavigation: () => {},
    }),
    [],
  );

  const [modalState, setModalState] = useState(defaultModalState);

  const resetModalState = useCallback(() => {
    setModalState(defaultModalState);
  }, [defaultModalState]);

  const handleNavigationAction = useCallback<INavigationActionHandler>(
    (actionFn) => {
      actionFn();

      resetModalState();
    },
    [resetModalState],
  );

  return (
    <NavigateBlockerContext.Provider value={{ setModalState, resetModalState }}>
      {children}
      {/* TODO: Remove DesignSystemThemeProvider in the future if themeProvider is replaced by it */}
      <DesignSystemThemeProvider>
        <Modal
          open={modalState.isOpen}
          onClose={() => handleNavigationAction(modalState.resetNavigation)}
          onCancelAction={() =>
            handleNavigationAction(modalState.resetNavigation)
          }
          onConfirmAction={() =>
            handleNavigationAction(modalState.proceedNavigation)
          }
          title={lang.navigateBlockerModal.title}
          cancelButtonText={lang.navigateBlockerModal.cancelText}
          confirmButtonText={lang.navigateBlockerModal.confirmText}>
          <Typography variant="body2">
            {lang.navigateBlockerModal.subTitle}
          </Typography>
        </Modal>
      </DesignSystemThemeProvider>
    </NavigateBlockerContext.Provider>
  );
};
